import Airbnb from './Airbnb'
import './App.css';

function App() {
  return (
    <div className="App">
     <Airbnb/>
    </div>
  );
}

export default App;
